import { useEffect, useState } from 'react';
import { topUsers, researchArticle, dailyDiscussion, sponsoredProduct } from '../data/data';
import { ProductCard } from '../components/ProductCard';
import { useNavigate } from 'react-router-dom';
import SponsoredProductsSection from '../components/SponsoredProducts';
import API_URL from "../config/ApiUrl";
import { CommunityStatsCard } from '../components/CommunityStats';
import { useTheme } from '../arrangement/ThemeContext';
import PublicProfileView from '../profile_component/PublicProfileViewPage';
import SmokerLevelsCard from '../components/SmokerLevel';
export function HomePage() {
    const { colors } = useTheme();
    const [topUsers, setTopUsers] = useState([]);
    const [loadingTop, setLoadingTop] = useState(true);
    const navigate = useNavigate();
    const [showProfileView, setShowProfileView] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);

    const getSmokerEmoji = (level) => {
        switch(level) {
            case 'beginner': return 'https://highmind-bucket.s3.us-east-1.amazonaws.com/cdb53b7a8c7e4624a810c0d654ca03c8_Smoker_beginer.webp';
            case 'casual': return 'https://highmind-bucket.s3.us-east-1.amazonaws.com/e72017f33d1c480db1928ca3d7295de4_Smoker_Level_cas.webp';
            case 'connoisseur': return 'https://highmind-bucket.s3.us-east-1.amazonaws.com/3e1e13711dd441fcb7c34c155416ee69_Smoker_Level_con.webp';
            case 'stoner': return 'https://highmind-bucket.s3.us-east-1.amazonaws.com/9084554e27d747188148530bc7899eee_Smoker_Level_Logo_Stoner.webp';
            default: return 'https://highmind-bucket.s3.us-east-1.amazonaws.com/6d4ba06007624c3691fd682dfbb31cdf_hmind.png'
        }
    };
    

    // NEW: Trending discussions state
    const [trendingDiscussions, setTrendingDiscussions] = useState([]);
    const [loadingTrending, setLoadingTrending] = useState(true);

    const [todaysResearch, setTodaysResearch] = useState(null);
    const [loadingResearch, setLoadingResearch] = useState(true);

    const handleOpenResearch = (article) => {
        navigate(`/research?article=${article.id}`);
    };

    // Fetch top 3 contributors
    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${API_URL}/top3`, { credentials: 'include' });
                const json = await res.json();
                if (json?.success && Array.isArray(json.data)) {
                    setTopUsers(json.data);
                } else {
                    setTopUsers([]);
                }
            } catch (e) {
                console.error('Failed to load top contributors', e);
                setTopUsers([]);
            } finally {
                setLoadingTop(false);
            }
        })();
    }, []);

    // Fetch today's research
    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${API_URL}/api/research/todays-research`, { credentials: 'include' });
                const json = await res.json();
                if (json?.success) {
                    setTodaysResearch(json.data);
                } else {
                    setTodaysResearch(null);
                }
            } catch (e) {
                console.error('Failed to load today\'s research', e);
                setTodaysResearch(null);
            } finally {
                setLoadingResearch(false);
            }
        })();
    }, []);

    // NEW: Fetch trending discussions
    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${API_URL}/trending-discussions?limit=3`, { credentials: 'include' });
                const json = await res.json();
                if (json?.success && Array.isArray(json.data)) {
                    setTrendingDiscussions(json.data);
                } else {
                    setTrendingDiscussions([]);
                }
            } catch (e) {
                console.error('Failed to load trending discussions', e);
                setTrendingDiscussions([]);
            } finally {
                setLoadingTrending(false);
            }
        })();
    }, []);

    const handleUsernameClick = (userId) => {
        console.log('====================HANDLE GET CLICK ========================')
        console.log(userId)
        console.log('====================HANDLE GET CLICK ========================')

        setSelectedUserId(userId);
        setShowProfileView(true);
        
    };

    const isMobile = window.innerWidth <= 768;
    
    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#0a0a0a',
            color: 'white',
            fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
            <main style={{
                maxWidth: '75rem',
                margin: '0 auto',
                padding: isMobile ? '1.5rem 1rem' : '2.5rem 1.25rem'
            }}>
                {/* Hero Section */}
                <section style={{
                    textAlign: 'center',
                    marginBottom: isMobile ? '2rem' : '3rem'
                }}>
                    <h1 style={{
                        fontSize: isMobile ? '2rem' : '3rem',
                        fontWeight: '700',
                        margin: '0 0 1rem 0',
                        letterSpacing: '-0.02em'
                    }}>
                        Welcome to the Oak Community
                    </h1>
                    <p style={{
                        fontSize: isMobile ? '1rem' : '1.125rem',
                        color: '#888',
                        maxWidth: '37.5rem',
                        margin: '0 auto',
                        lineHeight: '1.6',
                        padding: isMobile ? '0 1rem' : '0'
                    }}>
                        The trusted space to explore products, share experiences, and learn together.
                    </p>
                </section>

                {/* Main Layout - Responsive Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr',
                    gap: isMobile ? '1.5rem' : '2rem',
                    marginBottom: '5%'
                }}>
                    {/* Left Column - TRENDING DISCUSSIONS & RESEARCH */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: isMobile ? '1.5rem' : '2rem'
                    }}>
                        {/* TRENDING DISCUSSIONS SECTION */}
                        <div style={{
                            backgroundColor: colors.bgCard,
                            border: `1px solid ${colors.border}`,
                            borderRadius: '0.75rem',
                            overflow: 'hidden',
                        }}>
                            <div style={{ 
                                padding: isMobile ? '1rem' : '1.25rem', 
                                borderBottom: `1px solid ${colors.border}`,
                                backgroundColor: '#1a1a1a',
                            }}>
                                <h3 style={{ 
                                    fontSize: isMobile ? '1.25rem' : '1.5rem', 
                                    fontWeight: 600, 
                                    margin: 0, 
                                    color: colors.textPrimary,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                }}>
                                    🔥 Trending Discussions
                                </h3>
                                <p style={{ 
                                    margin: '0.5rem 0 0 0', 
                                    color: colors.textSecondary, 
                                    fontSize: '0.875rem' 
                                }}>
                                    What the community is talking about
                                </p>
                            </div>

                            <div style={{ padding: isMobile ? '1rem' : '.5rem' }}>
                                {loadingTrending ? (
                                    <div style={{ color: colors.textSecondary, textAlign: 'center', padding: '2rem' }}>
                                        Loading discussions...
                                    </div>
                                ) : trendingDiscussions.length === 0 ? (
                                    <div style={{ color: colors.textSecondary, textAlign: 'center', padding: '2rem' }}>
                                        No discussions yet. Be the first to start one!
                                    </div>
                                ) : (
                                    <div style={{ 
                                        display: 'flex', 
                                        flexDirection: 'column', 
                                        gap: isMobile ? '1rem' : '.5rem' 
                                    }}>
                                        {trendingDiscussions.map((discussion, index) => (
                                            <div 
                                                key={discussion.id}
                                                style={{
                                                    padding: isMobile ? '1rem' : '.75rem',
                                                    backgroundColor: index === 0 ? `${colors.accentPrimary}10` : colors.bgSecondary1,
                                                    borderRadius: '0.75rem',
                                                    border: index === 0 ? `2px solid ${colors.accentPrimary}40` : `1px solid ${colors.border}`,
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    position: 'relative'
                                                }}
                                                onClick={() => navigate(`/threads`)}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                    e.currentTarget.style.borderColor = colors.accentPrimary;
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.borderColor = index === 0 ? `${colors.accentPrimary}40` : colors.border;
                                                }}
                                            >
                                                {/* Top Badge for #1 */}
                                                {index === 0 && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: isMobile ? '7rem' : '7rem',
                                                        right: isMobile ? '0.5rem' : '0.75rem',
                                                        backgroundColor: colors.accentPrimary,
                                                        color: colors.bgPrimary,
                                                        padding: '0.25rem 0.5rem',
                                                        borderRadius: '0.25rem',
                                                        fontSize: isMobile ? '0.625rem' : '0.7rem',
                                                        fontWeight: '700',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.05em'
                                                    }}>
                                                        🔥 Hottest
                                                    </div>
                                                )}

                                                {/* User Info */}
                                                <div style={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: '10px', 
                                                    marginBottom: '12px'
                                                }}>
                                                    <div style={{ position: 'relative' }}>
                                                        <img
                                                            src={discussion.avatar || discussion.user_avatar || '/default-avatar.png'}
                                                            alt={discussion.display_name || discussion.author}
                                                            style={{
                                                                width: isMobile ? '32px' : '36px',
                                                                height: isMobile ? '32px' : '36px',
                                                                borderRadius: '8px',
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                        
                                                        {discussion.author_smoke_level && (
                                                            <div style={{
                                                                position: 'absolute',
                                                                bottom: '-4px',
                                                                right: '-4px',
                                                                backgroundColor: colors.bgSecondary,
                                                                borderRadius: '50%',
                                                                width: isMobile ? '18px' : '20px',
                                                                height: isMobile ? '18px' : '20px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                border: `1px solid ${colors.accentPrimary}`
                                                            }}>
                                                                <img 
                                                                    src={getSmokerEmoji(discussion.author_smoke_level)}
                                                                    alt={`(${discussion.author_smoke_level})`}
                                                                    style={{
                                                                        width: isMobile ? '14px' : '16px',
                                                                        height: isMobile ? '14px' : '16px',
                                                                        borderRadius: '50%',
                                                                        objectFit: 'cover'
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ 
                                                            fontSize: isMobile ? '0.75rem' : '0.875rem', 
                                                            fontWeight: '600', 
                                                            color: colors.textPrimary
                                                        }}>
                                                            {discussion.display_name || discussion.author}
                                                        </div>
                                                        <div style={{ 
                                                            fontSize: isMobile ? '0.625rem' : '0.75rem', 
                                                            color: colors.textSecondary,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px'
                                                        }}>
                                                            {discussion.author_smoke_level && (
                                                                <>
                                                                    <span style={{ 
                                                                        color: colors.accentPrimary,
                                                                        textTransform: 'capitalize',
                                                                        fontSize: isMobile ? '0.625rem' : '0.7rem'
                                                                    }}>
                                                                        ({discussion.author_smoke_level})
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {discussion.author_reputation > 0 && (
                                                        <div style={{
                                                            backgroundColor: `${colors.accentPrimary}20`,
                                                            padding: '4px 8px',
                                                            borderRadius: '6px',
                                                            fontSize: isMobile ? '0.625rem' : '0.7rem',
                                                            fontWeight: '600',
                                                            color: colors.accentPrimary
                                                        }}>
                                                            {discussion.author_reputation} Rep
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Discussion Title */}
                                                <h4 style={{
                                                    fontSize: isMobile ? '0.95rem' : '1.1rem',
                                                    fontWeight: 600,
                                                    margin: '0 0 8px 0',
                                                    color: colors.textPrimary,
                                                    lineHeight: '1.3'
                                                }}>
                                                    {discussion.title}
                                                </h4>

                                                {/* Description (only for #1) */}
                                                {index === 0 && discussion.description && (
                                                    <p style={{
                                                        fontSize: isMobile ? '0.75rem' : '0.875rem',
                                                        color: colors.textSecondary,
                                                        margin: '0 0 12px 0',
                                                        lineHeight: '1.4',
                                                        overflow: 'hidden',
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: 'vertical'
                                                    }}>
                                                        {discussion.description}
                                                    </p>
                                                )}

                                                {/* Stats */}
                                                <div style={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: '16px',
                                                    fontSize: isMobile ? '0.7rem' : '0.8rem'
                                                }}>
                                                    <span style={{ color: colors.textSecondary }}>
                                                        💬 {discussion.replies} {discussion.replies === 1 ? 'reply' : 'replies'}
                                                    </span>
                                                    
                                                    {discussion.likes !== undefined && (
                                                        <span style={{ 
                                                            color: colors.textSecondary,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '4px'
                                                        }}>
                                                            <span style={{ color: colors.accentPrimary }}>↑</span>
                                                            {discussion.likes}
                                                        </span>
                                                    )}

                                                    {discussion.is_today && (
                                                        <span style={{
                                                            marginLeft: 'auto',
                                                            backgroundColor: `${colors.accentPrimary}20`,
                                                            color: colors.accentPrimary,
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: isMobile ? '0.625rem' : '0.7rem',
                                                            fontWeight: '600'
                                                        }}>
                                                            NEW TODAY
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* RESEARCH SECTION - Compact Version */}
                        <div style={{
                            backgroundColor: colors.bgCard,
                            border: `1px solid ${colors.border}`,
                            borderRadius: '0.75rem',
                            overflow: 'hidden'
                        }}>
                            <div style={{ 
                                padding: isMobile ? '1rem' : '1.5rem', 
                                borderBottom: `1px solid ${colors.border}`,
                                backgroundColor: '#1a1a1a',
                            }}>
                                <h3 style={{ 
                                    fontSize: isMobile ? '1.25rem' : '1.5rem', 
                                    fontWeight: 600, 
                                    margin: 0, 
                                    color: colors.textPrimary,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                }}>
                                    🧠 Knowledge is Power
                                </h3>
                                <p style={{ 
                                    margin: '0.5rem 0 0 0', 
                                    color: colors.textSecondary, 
                                    fontSize: '0.875rem' 
                                }}>
                                    Featured research article
                                </p>
                            </div>

                            <div style={{ padding: isMobile ? '1rem' : '1.5rem' }}>
                                {loadingResearch ? (
                                    <div style={{ padding: isMobile ? '1rem' : '1.5rem', textAlign: 'center', color: colors.textSecondary }}>
                                        Loading research...
                                    </div>
                                ) : !todaysResearch ? (
                                    <div style={{ padding: isMobile ? '1rem' : '1.5rem', textAlign: 'center', color: colors.textSecondary }}>
                                        No research articles available yet.
                                    </div>
                                ) : (
                                    <>
                                        <h3 style={{
                                            fontSize: isMobile ? '1rem' : '1.125rem',
                                            fontWeight: '600',
                                            margin: '0 0 0.75rem 0',
                                            color: colors.textPrimary,
                                            lineHeight: '1.3'
                                        }}>
                                            {todaysResearch.title}
                                        </h3>

                                        {/* Article Metadata */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: isMobile ? '8px' : '12px',
                                            marginBottom: '1rem',
                                            fontSize: isMobile ? '0.625rem' : '0.75rem',
                                            color: colors.textSecondary,
                                            flexWrap: 'wrap'
                                        }}>
                                            <span>{todaysResearch.author}</span>
                                            {todaysResearch.institution && (
                                                <>
                                                    <span>•</span>
                                                    <span>{todaysResearch.institution}</span>
                                                </>
                                            )}
                                            <span>•</span>
                                            <span>{todaysResearch.published_date}</span>
                                        </div>

                                        {/* Engagement Stats */}
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: isMobile ? '14px' : '20px',
                                            marginBottom: '1rem',
                                            flexWrap: 'wrap'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: colors.textSecondary }}>
                                                <span>👁️</span>
                                                <span style={{ fontSize: isMobile ? '0.625rem' : '0.75rem' }}>{todaysResearch.view_count} views</span>
                                            </div>
                                            
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: colors.textSecondary }}>
                                                <span style={{ color: colors.accentPrimary }}>↑</span>
                                                <span style={{ fontSize: isMobile ? '0.625rem' : '0.75rem' }}>{todaysResearch.like_count} likes</span>
                                            </div>
                                            
                                            {todaysResearch.read_time && (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: colors.textSecondary }}>
                                                    <span>⏱️</span>
                                                    <span style={{ fontSize: isMobile ? '0.625rem' : '0.75rem' }}>{todaysResearch.read_time} min read</span>
                                                </div>
                                            )}
                                        </div>

                                        {/* Submitter Info */}
                                        {todaysResearch.submitter && (
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                padding: '18px',
                                                backgroundColor: `${colors.accentPrimary}10`,
                                                borderRadius: '6px',
                                                marginBottom: '1rem'
                                            }}>
                                                <img
                                                    src={`https://highmind-bucket.s3.us-east-1.amazonaws.com/${todaysResearch.submitter.avatar}` || todaysResearch.submitter.profile_image_url}
                                                    alt={todaysResearch.submitter.username}
                                                    style={{
                                                        width: isMobile ? '26px' : '40px',
                                                        height: isMobile ? '26px' : '40px',
                                                        borderRadius: '4px',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                                <span style={{ fontSize: isMobile ? '0.725rem' : '0.95rem', fontWeight: 'bold',color: colors.textSecondary }}>
                                                    Submitted by {todaysResearch.submitter.display_name}
                                                </span>
                                                
                                                {todaysResearch.submitter.smoker_level && (
                                                    <>
                                                        <span style={{
                                                            color: colors.textSecondary,
                                                            fontSize: isMobile ? '0.625rem' : '0.75rem'
                                                        }}>•</span>
                                                        <span style={{
                                                            fontSize: isMobile ? '0.5rem' : '0.625rem',
                                                            color: colors.accentPrimary,
                                                            textTransform: 'capitalize'
                                                        }}>
                                                            ({todaysResearch.submitter.smoker_level})
                                                        </span>
                                                    </>
                                                )}
                                                <img 
                                                    src={getSmokerEmoji(todaysResearch.submitter.smoker_level)}
                                                    alt={`(${todaysResearch.submitter.smoker_level})`}
                                                    style={{
                                                        width: isMobile ? '34px' : '46px',
                                                        height: isMobile ? '34px' : '46px',
                                                        borderRadius: '50%',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            </div>
                                        )}

                                        {/* Action Button */}
                                        <button
                                            onClick={() => handleOpenResearch(todaysResearch)}
                                            style={{
                                                width: '100%',
                                                backgroundColor: colors.accentPrimary,
                                                color: colors.bgPrimary,
                                                border: 'none',
                                                borderRadius: '0.5rem',
                                                padding: isMobile ? '0.625rem 1rem' : '0.75rem 1rem',
                                                fontSize: isMobile ? '0.75rem' : '0.875rem',
                                                fontWeight: 600,
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '0.5rem',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = colors.accentSecondary;
                                                e.currentTarget.style.transform = 'translateY(-1px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = colors.accentPrimary;
                                                e.currentTarget.style.transform = 'translateY(0)';
                                            }}
                                        >
                                            🔬 Read Full Study →
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Community Podium (unchanged) */}
                    <div>
                        <div style={{
                            backgroundColor: '#1a1a1a',
                            border: '1px solid #333',
                            borderRadius: '0.75rem',
                            marginBottom: '7.5%',
                            overflow: 'hidden'
                          }}>   
                            <div style={{ padding: isMobile ? '1rem' : '1.25rem', borderBottom: '1px solid #333' }}>
                                <h3 style={{
                                    fontSize: isMobile ? '1.25rem' : '1.5rem',
                                    fontWeight: 600,
                                    margin: 0,
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                }}>
                                    🏆 Community Podium
                                </h3>
                                <p style={{ margin: '0.5rem 0 0 0', color: '#888', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>
                                    This week's top contributors
                                </p>
                            </div>

                            {loadingTop ? (
                                <div style={{ padding: '1rem', color: '#888', textAlign: 'center' }}>Loading top contributors…</div>
                            ) : topUsers.length < 3 ? (
                                <div style={{ padding: '1rem', color: '#888', textAlign: 'center' }}>Not enough data yet.</div>
                            ) : null}

                            {/* Podium */}
                            <div style={{
                                padding: isMobile ? '1rem' : '1.25rem',
                                display: 'grid',
                                gap: isMobile ? '0.75rem' : '1rem'
                            }}>
                                {/* Avatars row */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr 1fr',
                                    alignItems: 'end',
                                    gap: isMobile ? '0.5rem' : '0.75rem',
                                    textAlign: 'center',
                                    minHeight: isMobile ? '7rem' : '11rem',  // ADD THIS - reserves space
                                }}>
                                    {/* 2nd place (left) */}
                                    <div>
                                        <div style={{
                                            width: isMobile ? '3.5rem' : '4.5rem',
                                            height: isMobile ? '3.5rem' : '4.5rem',
                                            margin: '0 auto',
                                            backgroundColor: '#2a2a2a',
                                            border: '0.1875rem solid #9ca3af',
                                            borderRadius: '50%',
                                            backgroundImage: topUsers?.[1]?.avatar ? `url(${topUsers[1].avatar})` : 'none',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            flexShrink: 0,  // ADD THIS
                                            minHeight: isMobile ? '3.5rem' : '4.5rem',  // ADD THIS
                                        }} />

                                        <div style={{ marginTop: '0.5rem', color: 'white', fontWeight: 600, fontSize: isMobile ? '0.8rem' : '0.95rem' }}>
                                            {topUsers?.[1]?.name ?? '—'}
                                        </div>
                                        <div style={{ color: '#9ca3af', fontSize: isMobile ? '0.7rem' : '0.8rem' }}>
                                            🥈 {topUsers?.[1]?.reputation?.toLocaleString?.() ?? 0} Rep
                                        </div>
                                    </div>

                                    {/* 1st place (center) */}
                                    <div>
                                       <div style={{
                                          width: isMobile ? '4rem' : '5rem',
                                          height: isMobile ? '4rem' : '5rem',
                                          margin: '0 auto',
                                          backgroundColor: '#2a2a2a',
                                          border: '0.1875rem solid #fbbf24',
                                          borderRadius: '50%',
                                          backgroundImage: topUsers?.[0]?.avatar ? `url(${topUsers[0].avatar})` : 'none',
                                          backgroundSize: 'cover',
                                          backgroundPosition: 'center',
                                          position: 'relative',
                                          flexShrink: 0,  // ADD THIS
                                          minHeight: isMobile ? '4rem' : '5rem',  // ADD THIS
                                      }}>

                                            <span style={{
                                                position: 'absolute',
                                                top: isMobile ? '-0.7rem' : '-0.9rem',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                fontSize: isMobile ? '1rem' : '1.25rem'
                                            }}>👑</span>
                                        </div>
                                        <div style={{ marginTop: '0.5rem', color: 'white', fontWeight: 700, fontSize: isMobile ? '0.85rem' : '1rem' }}>
                                            {topUsers?.[0]?.name ?? '—'}
                                        </div>
                                        <div style={{ color: '#fbbf24', fontSize: isMobile ? '0.75rem' : '0.9rem', fontWeight: 600 }}>
                                            🥇 {topUsers?.[0]?.reputation?.toLocaleString?.() ?? 0} Rep
                                        </div>
                                    </div>

                                    {/* 3rd place (right) */}
                                    <div>
                                        <div style={{
                                              width: isMobile ? '3.25rem' : '4.25rem',
                                              height: isMobile ? '3.25rem' : '4.25rem',
                                              margin: '0 auto',
                                              backgroundColor: '#2a2a2a',
                                              border: '0.1875rem solid #b45309',
                                              borderRadius: '50%',
                                              backgroundImage: topUsers?.[2]?.avatar ? `url(${topUsers[2].avatar})` : 'none',
                                              backgroundSize: 'cover',
                                              backgroundPosition: 'center',
                                              flexShrink: 0,  // ADD THIS
                                              minHeight: isMobile ? '3.25rem' : '4.25rem',  // ADD THIS
                                          }} />
                                        <div style={{ marginTop: '0.5rem', color: 'white', fontWeight: 600, fontSize: isMobile ? '0.8rem' : '0.95rem' }}>
                                            {topUsers?.[2]?.name ?? '—'}
                                        </div>
                                        <div style={{ color: '#b45309', fontSize: isMobile ? '0.7rem' : '0.8rem' }}>
                                            🥉 {topUsers?.[2]?.reputation?.toLocaleString?.() ?? 0} Rep
                                        </div>
                                    </div>
                                </div>

                                {/* Blocks (podium steps) */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr 1fr',
                                    alignItems: 'end',
                                    gap: isMobile ? '0.5rem' : '0.75rem',
                                    height: isMobile ? '6rem' : '8.75rem'
                                }}>
                                    {/* 2nd place block */}
                                    <div style={{
                                        background: 'linear-gradient(180deg, #374151 0%, #1f2937 100%)',
                                        border: '1px solid #4b5563',
                                        borderRadius: '0.5rem',
                                        height: isMobile ? '4.5rem' : '6.875rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#9ca3af',
                                        fontWeight: 700,
                                        fontSize: isMobile ? '1rem' : '1.25rem'
                                    }}>
                                        2
                                    </div>

                                    {/* 1st place block */}
                                    <div style={{
                                        background: 'linear-gradient(180deg, #f59e0b 0%, #92400e 100%)',
                                        border: '1px solid #fbbf24',
                                        borderRadius: '0.5rem',
                                        height: isMobile ? '6rem' : '8.75rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'black',
                                        fontWeight: 800,
                                        fontSize: isMobile ? '1.25rem' : '1.5rem'
                                    }}>
                                        1
                                    </div>

                                    {/* 3rd place block */}
                                    <div style={{
                                        background: 'linear-gradient(180deg, #92400e 0%, #451a03 100%)',
                                        border: '1px solid #b45309',
                                        borderRadius: '0.5rem',
                                        height: isMobile ? '3.75rem' : '5.625rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#f59e0b',
                                        fontWeight: 700,
                                        fontSize: isMobile ? '1rem' : '1.25rem'
                                    }}>
                                        3
                                    </div>
                                </div>

                                {/* CTA buttons */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr 1fr',
                                    gap: isMobile ? '0.5rem' : '0.75rem'
                                }}>
                                    <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUsernameClick(topUsers?.[1]?.id);
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#444';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#333';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                        }}
                                        style={{
                                            backgroundColor: '#333',
                                            color: 'white',
                                            border: '1px solid #444',
                                            borderRadius: '0.5rem',
                                            padding: isMobile ? '0.375rem 0.5rem' : '0.5rem 0.75rem',
                                            fontSize: isMobile ? '0.75rem' : '0.875rem',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}>
                                            View {topUsers?.[1]?.name?.split(' ')?.[0] ?? '2nd'}
                                    </button>

                                    <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUsernameClick(topUsers?.[0]?.id);
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#00f5c8';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 212, 170, 0.3)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#00d4aa';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                        style={{
                                            backgroundColor: '#00d4aa',
                                            color: 'black',
                                            border: 'none',
                                            borderRadius: '0.5rem',
                                            padding: isMobile ? '0.375rem 0.5rem' : '0.5rem 0.75rem',
                                            fontSize: isMobile ? '0.8rem' : '0.9rem',
                                            fontWeight: 800,
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}>
                                            View {topUsers?.[0]?.name?.split(' ')?.[0] ?? 'Winner'}
                                    </button>

                                    <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleUsernameClick(topUsers?.[2]?.id);
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#444';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#333';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                        }}
                                        style={{
                                            backgroundColor: '#333',
                                            color: 'white',
                                            border: '1px solid #444',
                                            borderRadius: '0.5rem',
                                            padding: isMobile ? '0.375rem 0.5rem' : '0.5rem 0.75rem',
                                            fontSize: isMobile ? '0.75rem' : '0.875rem',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}>
                                            View {topUsers?.[2]?.name?.split(' ')?.[0] ?? '3rd'}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <CommunityStatsCard />
                          <SmokerLevelsCard />

                    </div>
                    
                </div>

                <section style={{ marginBottom: isMobile ? '2rem' : '3rem' }}>
                    <SponsoredProductsSection />
                </section>

                <section style={{
                    marginBottom: '3rem',
                    background: 'linear-gradient(135deg, rgba(0, 212, 170, 0.15) 0%, rgba(16, 185, 129, 0.1) 50%, rgba(5, 150, 105, 0.05) 100%)',
                    border: '1px solid rgba(0, 212, 170, 0.3)',
                    borderRadius: '1.5rem',
                    padding: isMobile ? '2rem 1.5rem' : '3rem 2.5rem',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    {/* Background Pattern */}
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: 'radial-gradient(circle at 30% 20%, rgba(0, 212, 170, 0.1) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(16, 185, 129, 0.1) 0%, transparent 50%)',
                        pointerEvents: 'none'
                    }} />

                    <div style={{
                        position: 'relative',
                        textAlign: 'center',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        {/* Badge */}
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: isMobile ? '0.5rem 1rem' : '0.75rem 1.5rem',
                            background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                            color: 'black',
                            borderRadius: '2rem',
                            fontSize: isMobile ? '0.75rem' : '0.875rem',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            marginBottom: isMobile ? '1.5rem' : '2rem'
                        }}>
                            <span>📱</span>
                            Coming Soon
                        </div>

                        {/* Heading */}
                        <h2 style={{
                            fontSize: isMobile ? '2rem' : '2.75rem',
                            fontWeight: '800',
                            margin: '0 0 1rem 0',
                            color: 'white',
                            lineHeight: '1.1'
                        }}>
                            Oak Mobile App
                        </h2>

                        <h3 style={{
                            fontSize: isMobile ? '1.125rem' : '1.25rem',
                            fontWeight: '600',
                            margin: '0 0 1.5rem 0',
                            color: '#00d4aa'
                        }}>
                            Your community, now in your pocket
                        </h3>

                        {/* Description */}
                        <p style={{
                            fontSize: isMobile ? '1rem' : '1.125rem',
                            color: colors.textSecondary,
                            lineHeight: '1.6',
                            margin: '0 0 2rem 0'
                        }}>
                            We're building the ultimate mobile experience for the Oak Community. Get ready to explore products, 
                            engage in discussions, and stay connected with fellow enthusiasts wherever you go.
                        </p>

                        {/* Features grid */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                            gap: isMobile ? '1rem' : '1.5rem',
                            marginBottom: '2.5rem'
                        }}>
                            {[
                                { icon: '🔍', text: 'Browse Products' },
                                { icon: '💬', text: 'Join Discussions' },
                                { icon: '📊', text: 'Review Products' },
                                { icon: '🔔', text: 'Join Sesh Rooms' }
                            ].map((feature, index) => (
                                <div key={index} style={{
                                    padding: isMobile ? '1rem' : '1.5rem',
                                    backgroundColor: 'rgba(0, 212, 170, 0.1)',
                                    borderRadius: '1rem',
                                    border: '1px solid rgba(0, 212, 170, 0.2)',
                                    textAlign: 'center'
                                }}>
                                    <div style={{ fontSize: isMobile ? '1.5rem' : '2rem', marginBottom: '0.5rem' }}>
                                        {feature.icon}
                                    </div>
                                    <span style={{
                                        fontSize: isMobile ? '0.75rem' : '0.875rem',
                                        color: 'white',
                                        fontWeight: '600'
                                    }}>
                                        {feature.text}
                                    </span>
                                </div>
                            ))}
                        </div>

                        {/* CTA Button */}
                        <button style={{
                            background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                            color: 'black',
                            border: 'none',
                            borderRadius: '0.75rem',
                            padding: isMobile ? '1rem 2rem' : '1.25rem 2.5rem',
                            fontSize: isMobile ? '0.875rem' : '1rem',
                            fontWeight: '700',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            boxShadow: '0 4px 20px rgba(0, 212, 170, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 212, 170, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 212, 170, 0.3)';
                        }}
                        >
                            Get Notified When It's Ready →
                        </button>
                    </div>
                </section>
            </main>    
            {showProfileView && selectedUserId && (
                <PublicProfileView
                userId={selectedUserId}
                onClose={() => {
                    setShowProfileView(false);
                    setSelectedUserId(null);
                }}
                />
            )}  
        </div>
    );
}